function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { closeConfirmation, getAppConfig, openConfirmation, openGdpr, openModal, signIn } from "@common/actions";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link, NavLink, withRouter } from "react-router-dom";
import { validateEmail, validatePassword } from "@common/services/helpers";
import request from "@common/services/request";
import { parseJwt } from "@common/utils/helpers";
import { AUTH_PAGE_CONFIG, EMAIL, ERROR_SUBCODE_GEO_RESTRICTION, ERROR_SUBCODE_LOGIN_LIMIT, ERROR_SUBCODE_NO_GDPR_CONSENT, ERROR_SUBCODE_PROXY_RESTRICTION, GOOGLE_SIGNIN_CLIENT_ID, KEY_ENTER, KEY_SPACE, ROUTE_GOOGLE_SIGN_IN, ROUTE_LIVE, ROUTE_RESTRICTED_GEOGRAPHY, ROUTE_SIGN_IN, ROUTE_SIGN_UP, SIGN_IN_DEFAULT_REDIRECT, STATUS_CODE_SUCCESS, TERMS_AND_CONDITIONS } from "@config/constants";
import { isEmpty } from "lodash";
export var SignIn = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(SignIn, PureComponent);
    var _super = _create_super(SignIn);
    function SignIn(props) {
        _class_call_check(this, SignIn);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "renderBanTimeError", function() {
            var i18n = _this.props.i18n;
            var banTime = _this.state.banTime;
            var banTimeFormated = banTime && new Date(banTime * 1000).toISOString().slice(11, 19).split(":");
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        children: i18n.errors.error200049
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: i18n.errors.error200049detail
                    }),
                    banTimeFormated && /*#__PURE__*/ _jsxs("span", {
                        className: "remaining",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "remaining-time-title",
                                children: "".concat(i18n.authentication.limitTimeRemaining, ": ")
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "remaining-time",
                                children: Number.parseInt(banTimeFormated[0])
                            }),
                            i18n.times.hour,
                            /*#__PURE__*/ _jsx("span", {
                                className: "remaining-time",
                                children: Number.parseInt(banTimeFormated[1])
                            }),
                            i18n.times.minutes,
                            /*#__PURE__*/ _jsx("span", {
                                className: "remaining-time",
                                children: Number.parseInt(banTimeFormated[2])
                            }),
                            i18n.times.seconds
                        ]
                    })
                ]
            });
        });
        _define_property(_assert_this_initialized(_this), "renderGeoRestrictionError", function() {
            var i18n = _this.props.i18n;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        children: i18n.errors["error".concat(_this.state.serverErrorSubcode)]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: i18n.errors["error".concat(_this.state.serverErrorSubcode, "detail")]
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "common/assets/media/geo-lock-map.png",
                        className: "geolocation-map"
                    })
                ]
            });
        });
        _define_property(_assert_this_initialized(_this), "renderGoogleSignin", function() {
            google.accounts.id.initialize({
                client_id: GOOGLE_SIGNIN_CLIENT_ID,
                cancel_on_tap_outside: false,
                callback: _this.onGoogleSignIn,
                prompt_parent_id: "g_id_onload",
                ux_mode: "popup",
                use_fedcm_for_button: true,
                use_fedcm_for_prompt: true
            });
            // google.accounts.id.prompt();
            google.accounts.id.renderButton(document.getElementById("g_id_signin"), {
                theme: "outline",
                size: "large"
            });
        });
        _this.state = {
            email: "",
            emailError: "",
            emailTouched: false,
            grant_type: "client_credentials",
            password: "",
            passwordError: "",
            passwordTouched: false,
            rememberme: true,
            serverError: "",
            serverErrorSubcode: null,
            // banTime: null,
            googleUser: null,
            doesAgreeGdpr: ""
        };
        _this.onChange = _this.onChange.bind(_assert_this_initialized(_this));
        _this.signIn = _this.signIn.bind(_assert_this_initialized(_this));
        _this.onGoogleSignIn = _this.onGoogleSignIn.bind(_assert_this_initialized(_this));
        _this.declineGdprOnGoogleSignIn = _this.declineGdprOnGoogleSignIn.bind(_assert_this_initialized(_this));
        _this.openConfirmation = _this.openConfirmation.bind(_assert_this_initialized(_this));
        _this.loginGoogleKeyboard = _this.loginGoogleKeyboard.bind(_assert_this_initialized(_this));
        _this.banTimeTimer = null;
        _this.banTimeTimer = null;
        return _this;
    }
    _create_class(SignIn, [
        {
            /**
     * Mark all inputs that use validation
     * as touched, which will trigger
     * the validation (see `componentDidUpdate`).
     */ key: "markInputsAsTouched",
            value: function markInputsAsTouched() {
                this.setState({
                    emailTouched: true,
                    passwordTouched: true
                });
            }
        },
        {
            key: "signIn",
            value: /**
     * Sends user's credentials to the backend
     * if there are no email or password errors.
     * If server responds with specific error,
     * it sets `serverError` and marks text
     * inputs as touched.
     * @returns {Promise<void>}
     */ function signIn(event) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_state, email, emailError, emailTouched, grant_type, password, passwordError, passwordTouched, rememberme, trimmedEmail, errors1, hasInvalidInputDataAfterBlur, hasInvalidInputDataBeforeBlur, viewmap, route, error, hasSpecificServerError, _error_error_info;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                event.preventDefault();
                                _this_state = _this.state, email = _this_state.email, emailError = _this_state.emailError, emailTouched = _this_state.emailTouched, grant_type = _this_state.grant_type, password = _this_state.password, passwordError = _this_state.passwordError, passwordTouched = _this_state.passwordTouched, rememberme = _this_state.rememberme;
                                trimmedEmail = email.replace(/\s/g, "");
                                errors1 = _this.props.i18n.errors;
                                hasInvalidInputDataAfterBlur = emailError || passwordError;
                                hasInvalidInputDataBeforeBlur = !emailTouched && !validateEmail(email, null) || !passwordTouched && !validatePassword(password, null);
                                if (hasInvalidInputDataAfterBlur || hasInvalidInputDataBeforeBlur) {
                                    return [
                                        2,
                                        _this.markInputsAsTouched()
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                viewmap = _this.props.appConfig.viewmap;
                                return [
                                    4,
                                    _this.props.signIn({
                                        email: trimmedEmail,
                                        grant_type: grant_type,
                                        password: password,
                                        rememberme: rememberme,
                                        viewmap: viewmap
                                    })
                                ];
                            case 2:
                                _state.sent();
                                // Navigate user to the last requested route before the login
                                route = authentication.lastRequestedRoute || SIGN_IN_DEFAULT_REDIRECT;
                                _this.props.history.push(route);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                hasSpecificServerError = error && error.subcode;
                                if (hasSpecificServerError) {
                                    ;
                                    _this.setState({
                                        emailTouched: true,
                                        password: "",
                                        passwordTouched: true,
                                        serverError: errors1["error".concat(error.subcode)],
                                        serverErrorSubcode: error.subcode,
                                        banTime: (_error_error_info = error.error_info) === null || _error_error_info === void 0 ? void 0 : _error_error_info.banTime
                                    });
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Sets the new state for a given input.
     * @param {Object} event
     */ key: "onChange",
            value: function onChange(event) {
                var _event_target = event.target, checked = _event_target.checked, name = _event_target.name, type = _event_target.type, value = _event_target.value;
                var key = type === "checkbox" ? value : name;
                var newValue = type === "checkbox" ? checked : value;
                this.setState(_define_property({}, key, newValue));
            }
        },
        {
            /**
     * Opens google sign in iFrame on space/enter key
     * @param {Object} event
     */ key: "loginGoogleKeyboard",
            value: function loginGoogleKeyboard(event) {
                var key = event.which;
                if (key === KEY_ENTER || key === KEY_SPACE) {
                    var googleSignInButton = document.getElementsByClassName("abcRioButton")[0];
                    googleSignInButton.click();
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                var _this = this;
                var emailHasChangedOrEmpty = prevState.email !== this.state.email || this.state.email === "";
                var emailWasTouched = !prevState.emailTouched && this.state.emailTouched;
                var noServerError = this.state.serverError === "";
                if (emailHasChangedOrEmpty && this.state.emailTouched || emailWasTouched && noServerError) {
                    validateEmail(this.state.email, function(isValid) {
                        var emailError = isValid ? "" : _this.props.i18n.authentication.enterValidMail;
                        _this.setState({
                            emailError: emailError,
                            serverError: ""
                        });
                    });
                }
                if (this.state.passwordTouched) {
                    validatePassword(this.state.password, function(isValid) {
                        var passwordError = isValid ? "" : _this.props.i18n.authentication.enterPassword;
                        _this.setState({
                            passwordError: passwordError
                        });
                    });
                }
                if (this.state.banTime > 0 && prevState.banTime !== this.state.banTime) {
                    clearTimeout(this.banTimeTimer);
                    this.banTimeTimer = setTimeout(function() {
                        _this.setState({
                            banTime: _this.state.banTime - 1
                        });
                    }, 1000);
                } else if (!this.state.banTime && this.state.serverErrorSubcode === ERROR_SUBCODE_LOGIN_LIMIT) {
                    // Clear ban time handlers
                    this.setState({
                        serverErrorSubcode: null
                    });
                    this.renderGoogleSignin();
                }
            }
        },
        {
            /**
     * Renders the navigation links.
     * @returns {*}
     */ key: "renderNavigation",
            value: function renderNavigation() {
                var _this_props = this.props, disableNavigation = _this_props.disableNavigation, i18n = _this_props.i18n, noSignUpLink = _this_props.noSignUpLink, selectedLink = _this_props.selectedLink;
                var _i18n_authentication = i18n.authentication, _$signIn = _i18n_authentication.signIn, signUp = _i18n_authentication.signUp;
                var classes = "secondary-navigation".concat(noSignUpLink ? " single-link" : " two-links");
                disableNavigation && (classes += " no-navigation");
                selectedLink && (classes += " ".concat(selectedLink));
                return /*#__PURE__*/ _jsxs("div", {
                    className: classes,
                    children: [
                        /*#__PURE__*/ _jsx(NavLink, {
                            to: ROUTE_SIGN_IN,
                            activeClassName: "selected",
                            children: _$signIn
                        }),
                        AUTH_PAGE_CONFIG.REGISTRATION_ENABLED && /*#__PURE__*/ _jsx(NavLink, {
                            to: ROUTE_SIGN_UP,
                            activeClassName: "selected",
                            children: signUp
                        })
                    ]
                });
            }
        },
        {
            /**
     * Opens confirmation modal for agreement with terms and email gdpr
     */ key: "openConfirmation",
            value: function openConfirmation() {
                var _this = this;
                var _this_props = this.props, _$openConfirmation = _this_props.openConfirmation, i18n = _this_props.i18n;
                var messageClickableElements = [
                    {
                        element: '<button type="button"\n                                  id="terms"\n                                  class="translation-active confirmation">'.concat(i18n.authentication.theTerms, "</button>"),
                        id: "terms",
                        onClickMethod: function() {
                            _this.props.openModal(TERMS_AND_CONDITIONS, {
                                title: i18n.termsAndConditions.title,
                                text: i18n.termsAndConditions.text
                            });
                        }
                    },
                    {
                        element: '<button type="button"\n                                  id="email"\n                                  class="translation-active confirmation">'.concat(i18n.authentication.provideYourEmail, "</button>"),
                        id: EMAIL,
                        onClickMethod: function() {
                            _this.props.openGdpr(EMAIL);
                        }
                    }
                ];
                _$openConfirmation({
                    message: i18n.authentication.googleSignUpConfirmation,
                    hasClickableElements: true,
                    highlightConfirm: true,
                    title: i18n.authentication.welcomeToElemental,
                    messageClickableElements: messageClickableElements,
                    declineMethod: this.declineGdprOnGoogleSignIn,
                    confirmMethod: function() {
                        _this.setState({
                            doesAgreeGdpr: true
                        }, function() {
                            _this.onGoogleSignIn(_this.state.googleUser);
                        });
                    }
                });
            }
        },
        {
            key: "onGoogleSignIn",
            value: /**
     * Method responsible for google sign in. Makes request to Goggle Auth Api and
     * then makes a standart login request with the returned token from Google.
     * @param googleUser {Object}
     */ function onGoogleSignIn(googleUser1) {
                var _this = this;
                return _async_to_generator(function() {
                    var idToken, _this_state, rememberme, doesAgreeGdpr, viewmap, response, error, hasSpecificServerError, error1, hasSpecificServerError1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                idToken = googleUser1.credential;
                                _this.setState({
                                    googleUser: googleUser1
                                });
                                _this_state = _this.state, rememberme = _this_state.rememberme, doesAgreeGdpr = _this_state.doesAgreeGdpr;
                                viewmap = _this.props.appConfig.viewmap;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    request({
                                        method: "POST",
                                        url: ROUTE_GOOGLE_SIGN_IN,
                                        data: {
                                            idToken: idToken,
                                            gdpr: doesAgreeGdpr,
                                            rememberme: rememberme,
                                            viewmap: viewmap
                                        }
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                if (!(response.status === STATUS_CODE_SUCCESS)) return [
                                    3,
                                    6
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.props.signIn({}, response.data)
                                ];
                            case 4:
                                _state.sent();
                                _this.props.closeConfirmation();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                hasSpecificServerError = error && error.subcode;
                                if (hasSpecificServerError) {
                                    _this.setState({
                                        serverError: errors["error".concat(error.subcode)]
                                    });
                                }
                                _this.props.closeConfirmation();
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                error1 = _state.sent();
                                hasSpecificServerError1 = error1 && error1.subcode;
                                if (hasSpecificServerError1 && error1.subcode === ERROR_SUBCODE_NO_GDPR_CONSENT) {
                                    _this.openConfirmation();
                                } else if (hasSpecificServerError1 && error1.subcode === ERROR_SUBCODE_GEO_RESTRICTION) {
                                    _this.props.closeConfirmation();
                                    google.accounts.id.revoke(googleUser1.sub, function(done) {
                                        console.log(done.error);
                                        if (done.successful) _this.props.history.push(ROUTE_RESTRICTED_GEOGRAPHY);
                                    });
                                }
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Closes confirmation modal and signs out of Google
     */ key: "declineGdprOnGoogleSignIn",
            value: function declineGdprOnGoogleSignIn() {
                this.props.closeConfirmation();
                google.accounts.id.revoke(googleUser.sub);
            }
        },
        {
            /**
     * Renders the inputs.
     * @returns {*}
     */ key: "renderInputs",
            value: function renderInputs() {
                var _this = this;
                var _this_state = this.state, email = _this_state.email, emailError = _this_state.emailError, password = _this_state.password, passwordError = _this_state.passwordError, rememberme = _this_state.rememberme, serverError = _this_state.serverError;
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(TextField, {
                            className: "ux-text-field-root",
                            autoComplete: "off",
                            InputProps: {
                                onBlur: function() {
                                    return _this.setState({
                                        emailTouched: true
                                    });
                                },
                                className: "ux-input",
                                classes: {
                                    error: "ux-input-error"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            FormHelperTextProps: {
                                error: true,
                                classes: {
                                    root: "ux-form-helper-text"
                                }
                            },
                            error: emailError !== "" || serverError !== "",
                            helperText: serverError || emailError,
                            disabled: this.state.banTime,
                            id: "email",
                            type: "text",
                            name: "email",
                            value: email,
                            label: i18n.authentication.email,
                            onChange: this.onChange,
                            margin: "none"
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            className: "ux-text-field-root",
                            InputProps: {
                                onBlur: function() {
                                    return _this.setState({
                                        passwordTouched: true
                                    });
                                },
                                className: "ux-input password",
                                classes: {
                                    error: "ux-input-error"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            FormHelperTextProps: {
                                error: true,
                                classes: {
                                    root: "ux-form-helper-text"
                                }
                            },
                            error: passwordError !== "",
                            helperText: passwordError,
                            id: "password",
                            type: "password",
                            name: "password",
                            value: password,
                            label: i18n.authentication.password,
                            disabled: this.state.banTime,
                            onChange: this.onChange,
                            margin: "none"
                        }),
                        /*#__PURE__*/ _jsx(FormControlLabel, {
                            control: /*#__PURE__*/ _jsx(Checkbox, {
                                classes: {
                                    checked: "ux-checked"
                                },
                                type: "checkbox",
                                checked: rememberme,
                                onChange: this.onChange,
                                value: "rememberme"
                            }),
                            label: i18n.authentication.rememberMe,
                            classes: {
                                root: "ux-checkbox-label-root remember-me",
                                label: "ux-checkbox-label tiny-font"
                            }
                        })
                    ]
                });
            }
        },
        {
            /**
     * Renders errors
     */ key: "renderError",
            value: function renderError() {
                if ([
                    ERROR_SUBCODE_LOGIN_LIMIT,
                    ERROR_SUBCODE_GEO_RESTRICTION,
                    ERROR_SUBCODE_PROXY_RESTRICTION
                ].includes(this.state.serverErrorSubcode)) {
                    var errorTemplate = null;
                    if (this.state.serverErrorSubcode === ERROR_SUBCODE_LOGIN_LIMIT) errorTemplate = this.renderBanTimeError();
                    else if ([
                        ERROR_SUBCODE_GEO_RESTRICTION,
                        ERROR_SUBCODE_PROXY_RESTRICTION
                    ].includes(this.state.serverErrorSubcode)) errorTemplate = this.renderGeoRestrictionError();
                    return /*#__PURE__*/ _jsxs("div", {
                        className: "login-error-container",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: "/common/assets/media/error-warning.svg",
                                className: "login-error-icon"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "login-error-description-container",
                                children: errorTemplate
                            })
                        ]
                    });
                }
                return null;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        _this.props.getAppConfig();
                        _this.renderGoogleSignin();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "sign-in-component",
                    children: [
                        this.renderNavigation(),
                        /*#__PURE__*/ _jsx("div", {
                            className: "authentication-link-description margin-top-tiny margin-bottom-small",
                            children: i18n.authentication.signExistingAccount
                        }),
                        /*#__PURE__*/ _jsxs("form", {
                            onSubmit: this.signIn,
                            children: [
                                this.renderInputs(),
                                this.renderError(),
                                /*#__PURE__*/ _jsx(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    disabled: [
                                        ERROR_SUBCODE_GEO_RESTRICTION,
                                        ERROR_SUBCODE_PROXY_RESTRICTION
                                    ].includes(this.state.serverErrorSubcode) || this.state.banTime,
                                    className: "button raised full-width margin-top-tiny",
                                    type: "submit",
                                    children: i18n.authentication.signIn
                                })
                            ]
                        }),
                        AUTH_PAGE_CONFIG.FORGOTTEN_PASSWORD_ENABLED && /*#__PURE__*/ _jsx("div", {
                            className: "forgotten-password-link margin-top-small",
                            children: !(this.state.serverErrorSubcode === ERROR_SUBCODE_GEO_RESTRICTION) && /*#__PURE__*/ _jsxs(Link, {
                                to: "/forgotten-password",
                                children: [
                                    i18n.authentication.forgottenPassword,
                                    "?"
                                ]
                            })
                        }),
                        this.state.serverErrorSubcode !== ERROR_SUBCODE_GEO_RESTRICTION && !this.state.banTime && AUTH_PAGE_CONFIG.LOGIN_WITH_GOOGLE_ENABLED && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    id: "g_id_onload",
                                    "data-callback": "onGoogleSignIn",
                                    "data-prompt_parent_id": "g_id_onload",
                                    "data-auto_prompt": "true"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "g_id_signin",
                                    id: "g_id_signin",
                                    "data-type": "standard",
                                    "data-size": "large",
                                    "data-theme": "outline",
                                    "data-text": "sign_in_with",
                                    "data-shape": "rectangular",
                                    "data-logo_alignment": "left"
                                })
                            ]
                        }),
                        !isEmpty(AUTH_PAGE_CONFIG === null || AUTH_PAGE_CONFIG === void 0 ? void 0 : AUTH_PAGE_CONFIG.FORM_LOGO_URL) && /*#__PURE__*/ _jsx("div", {
                            className: "authentication-logo",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: AUTH_PAGE_CONFIG.FORM_LOGO_URL,
                                alt: AUTH_PAGE_CONFIG.FORM_LOGO_ALT
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return SignIn;
}(PureComponent);
var mapStateToProps = function(param) {
    var appConfig = param.appConfig, authentication1 = param.authentication;
    return {
        appConfig: appConfig,
        authentication: authentication1
    };
};
export default withRouter(connect(mapStateToProps, {
    signIn: signIn,
    openModal: openModal,
    openConfirmation: openConfirmation,
    openGdpr: openGdpr,
    closeConfirmation: closeConfirmation,
    getAppConfig: getAppConfig
})(SignIn));
